<template>
  <f-data-table id="route53-table"
                :expanded="true"
                heading="AWS Route53"
                icon=""
                :data-uri="data_uri"
                :columns="columns"
                :selectable-rows="false"
                :server-side="true">
    <template slot="_actions">
      <div class="kt-portlet__head-toolbar">
        <div class="kt-portlet__head-wrapper">
          <a type="button"
             class="btn btn-ss-standout btn-icon-sm"
             href="/admin/route53/create/">
            <i class="flaticon2-plus" />New Record Set
          </a>
        </div>
      </div>
    </template>

    <template slot="actions" slot-scope="props">
      <div class="row-action-cell">
        <div class="dropdown dropdown-inline">
          <button type="button" class="btn btn-clean btn-icon"
                  data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
            <i class="flaticon-more-1" />
          </button>
          <div class="dropdown-menu dropdown-menu-right" style="">
            <ul class="kt-nav">
              <li class="kt-nav__item">
                <a :href="`/admin/route53/${props.row.id}/edit`" class="kt-nav__link">
                  <span class="kt-nav__link-text"><i class="fa fa-pen" />Edit</span>
                </a>
              </li>
              <li class="kt-nav__item">
                <a href="javascript:;" class="kt-nav__link" @click="deleteRecordSet(props.row)">
                  <span style="color:red" class="kt-nav__link-text"><i class="fa fa-trash" /> Delete</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>

    <template slot="created_at" slot-scope="props">
      <span v-if="props.value">{{ formatDateTime(props.value) }}</span>
      <span v-else class="no-content-notice">None</span>
    </template>

    <template slot="updated_at" slot-scope="props">
      <span v-if="props.value">{{ formatDateTime(props.value) }}</span>
      <span v-else class="no-content-notice">None</span>
    </template>
  </f-data-table>
</template>

<script>
import toastr from 'toastr';
import FDataTable from "VuePartials/App/Storage/FDataTable/FDataTable";

export default {
  components: {
    FDataTable,
  },
  data() {
    return {
      data_uri: '/api/v1/admin/route53',
      columns: [
        {
          display: "Record name",
          field: "name",
          width: 300,
          min_width: 200,
          never_clip: true,
        },
        {
          display: "Value/Route traffic to",
          field: 'value',
          width: 300,
          min_width: 200,
          never_clip: true,
        },
        {
          width: 50,
          display: "Type",
          field: 'type',
        },
        {
          display: "Customer",
          field: 'customer_name',
        },
        {
          display: "Created At",
          field: 'created_at',
        },
        {
          display: "Updated At",
          field: 'updated_at',
        },
        {
          field: `actions`,
          display: ``,
          sortable: false,
          width: 150,
          never_clip: true,
        },
      ],
    };
  },

  methods: {
    async deleteRecordSet(row) {
      try {
        const res = (await axios.delete(`/api/v1/admin/route53/${row.id}`)).data;
        if (res.success) {
          toastr.success('Record deleted');
          location.reload();
        } else {
          toastr.error('Failed');
        }
      } catch (err) {
        toastr.error('Failed');
      }
    },
  },

};

</script>
